module.exports = __webpack_public_path__ + "static/img/tixbay-desc-poster.b3618b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tixbay-desc-poster.png
// module id = 2039
// module chunks = 153